import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AddTransferTemplatePage, { getDefaultData, getDefaultUI } from "components/pages/AddTransferTemplatePage";
import Classes from "model";

/**
 * @name CaptureAddTemplateMainLevelOfApproverDDOpen
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Transfer Templates" (abi22).
 */
export default function CaptureAddTemplateMainLevelOfApproverDDOpen(props) {
    // Initialize all the model classes
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "template", "name" ], "Sample")
    .update([ "template", "fromAccount" ], "6")
    .update([ "template", "toAccount" ], "5")
    .update([ "template", "defaultAmount" ], "100")
    .update([ "template", "maxAmount" ], "1000")
    .update([ "template", "note" ], "Demonstrate Template")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update([ "levelOfApprover", "isActive" ], true)
    .submit();

    return <AddTransferTemplatePage data={ data } ui={ ui } />
}